// extracted by mini-css-extract-plugin
module.exports = {"notes":"userNotes_notes__1R0Cq","itemListHeader":"userNotes_itemListHeader__1JEAI","itemList":"userNotes_itemList__1VPFw"};